import React from 'react';
import {Card, Grid} from '@mui/material';
import {Field, useFormikContext} from 'formik';
import {TextField} from 'formik-mui';

export default function EntryTwoEdit() {
  const {values} = useFormikContext();

  return (
    <Card className={'box-shadow'} sx={{p: 4, paddingBottom: 10}}>
      <Grid container spacing={1.5}>
        {values?.dimensions?.map((item, index) => {
          return (
            <Grid item sm={6} xs={12}>
              <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={item?.name}
                     name={`dimensions.${index}.value`} disabled
                     InputLabelProps={{
                       style: {fontSize: 14, color: '#929191'},
                       shrink: true,
                       marginDense: false
                     }}/>
            </Grid>
          )
        })}
      </Grid>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Dyes'}
             name={`catalogue.dyes`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Motifs'}
             name={`catalogue.motifs`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Description'}
             name={`catalogue.description`} disabled multiline minRows={3} maxRows={3}
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
    </Card>
  );
}